import _ from 'lodash'
import { resetActiveRoom } from './setActiveRoomActions'
import setActiveStep from './activeStepActions'

import generateUuid from '../utilities/api/generateUuid'
import getCookie from '../utilities/session/getCookie'
import setCookie from '../utilities/session/setCookie'
import removeCookie from '../utilities/session/removeCookie'
import triggerCustomGaEvent from '../utilities/analytics/triggerCustomGaEvent'
import {setProfileAuthentication, setProfileModalVisibility} from './setProfile'
import fetchAvailabilityData from './fetchAvailability'
import axios from 'axios'
import {getClientIdByHotelCode} from "../utilities/property/getClientIdByHotelCode";

export const FETCH_PROFILE_USER_BEGIN   = 'FETCH_PROFILE_USER_BEGIN'
export const FETCH_PROFILE_USER_SUCCESS = 'FETCH_PROFILE_USER_SUCCESS'
export const FETCH_PROFILE_USER_FAILURE = 'FETCH_PROFILE_USER_FAILURE'
export const SIGN_OUT_PROFILE_USER_BEGIN = 'SIGN_OUT_PROFILE_USER_BEGIN'
export const SIGN_OUT_PROFILE_USER_SUCCESS = 'SIGN_OUT_PROFILE_USER_SUCCESS'
export const SIGN_OUT_PROFILE_USER_FAILURE = 'SIGN_OUT_PROFILE_USER_FAILURE'

export const fetchProfileUserBegin = () => ({
	type: FETCH_PROFILE_USER_BEGIN,
})

export const fetchProfileUserSuccess = profileUser => ({
	type: FETCH_PROFILE_USER_SUCCESS,
	payload: profileUser
})

export const fetchProfileUserError = error => ({
	type: FETCH_PROFILE_USER_FAILURE,
	payload: { error }
})

export const signOutProfileUserBegin = () => ({
	type: SIGN_OUT_PROFILE_USER_BEGIN,
})

export const signOutProfileUserSuccess = () => ({
	type: SIGN_OUT_PROFILE_USER_SUCCESS
})

	export const signOutProfileUserError = () => ({
		type: SIGN_OUT_PROFILE_USER_FAILURE
	})

export default function fetchAccorProfileUser(bearerToken) {
	return (dispatch) => {
		dispatch(fetchProfileUserBegin());

    const queryString = require('query-string')
    const urlQuery = queryString.parse(window.location.search)

		const queryParams = new URLSearchParams()
		queryParams.append('filter', 'loyalty.loyaltyCards.card:isLastActiveCard=true;')

    let currentClientId = getClientIdByHotelCode(urlQuery.hotelCode);

		const api = `${process.env.REACT_APP_CRM_PROVIDER_URL}/customer/v1/contacts/me?${queryParams.toString()}`

		return axios.get(api, {
			headers: {
				'x-traceid': generateUuid().toString(),
				'x-origin': currentClientId,
				'apiKey': process.env.REACT_APP_CRM_API_KEY,
				'Authorization': `Bearer ${bearerToken}`,
				'Content-Type': 'application/json',
			}
		}).then((res) => {
			if (
				res &&
				res.data
			) {
				const userProfile = _.get(res, 'data.individual', null)
				const userPrefix = _.get(userProfile, 'individualName.civility', null)
				const userFirstName = _.get(userProfile, 'individualName.firstName', null)
				const userLastName = _.get(userProfile, 'individualName.lastName', null)
				const userLoyaltyId = _.get(res, 'data.loyalty.loyaltyCards.card[0].cardNumber', null)
				const userLoyaltyTier = _.get(res, 'data.loyalty.loyaltyCards.card[0].cardProduct.productTier', null)
				const userLoyaltyTierUpgrade = _.get(res, 'data.loyalty.memberInfo.nextTiering', null)
				const userLoyaltyRewardsPoints = _.get(res, 'data.loyalty.balances.nbPoints', null)
				const userNightsToUpgrade = _.get(res, 'data.loyalty.balances.nbNightsToNextTiering', null)
				const userMediums = _.get(res, 'data.contactMediums.contactMedium', [])

				let userAddressData = null
				let userPhoneData = null
				let userEmail = null

				for (const mediumKey in userMediums) {
					const currentMedium = userMediums[mediumKey]

					if (
						currentMedium.postalAddress &&
						!_.isEmpty(currentMedium.postalAddress)
					) {
						userAddressData = currentMedium.postalAddress
					}

					if (
						currentMedium.telephoneNumber &&
						!_.isEmpty(currentMedium.telephoneNumber)
					) {
						userPhoneData = currentMedium.telephoneNumber
					}

					if (
						currentMedium.emailContact &&
						currentMedium.emailContact.email &&
						currentMedium.emailContact.email !== ''
					) {
						userEmail  = currentMedium.emailContact.email
					}
				}

				let  userPhone = _.get(userPhoneData, 'phoneNumber', null)
				const userPhonePrefix = _.get(userPhoneData, 'phonePrefix', null)
				const userStateProv = _.get(userAddressData, 'stateCode', null)
				const userCountry = _.get(userAddressData, 'countryCode', null)

			// 	const userAddress = _.get(userProfile, 'addresses[0].address1')
			// 	const userCity = _.get(userProfile, 'addresses[0].city')
			// 	const userPostalCode = _.get(userProfile, 'addresses[0].zipCode')

				if (userLoyaltyId) {
					const uniqueLoyaltyId = `${userLoyaltyId}-${generateUuid()}`
					setCookie('flowSessionId', uniqueLoyaltyId, 1)
				}

				if (userPhonePrefix && userPhone) {
					userPhone = userPhonePrefix + ' ' + userPhone
				}

				const formattedUser = {
					loyaltyId: userLoyaltyId,
					loyaltyTier: userLoyaltyTier,
					loyaltyTierUpgrade: userLoyaltyTierUpgrade,
					loyaltyRewardsPoints: userLoyaltyRewardsPoints,
					nightsToUpgrade: userNightsToUpgrade,
					prefix: userPrefix,
					firstName: userFirstName,
					lastName: userLastName,
					phone: userPhone,
					// address1: userAddress,
					// city: userCity,
					stateProv: userStateProv,
					country: userCountry,
					// postal: userPostalCode,
					email: userEmail
				}

				// Dispatch adaDescription GA events
				const profileUserData = {
					prefix: userPrefix,
					// city: userCity,
					country: userCountry,
					// postal: userPostalCode,
					loyaltyTier: userLoyaltyTier,
					status: 'success'
				}

				triggerCustomGaEvent('analytics-profileFetchUser', profileUserData)

				dispatch(fetchProfileUserSuccess(formattedUser))
				dispatch(setProfileAuthentication(true))

				setTimeout(() => {
					dispatch(fetchAvailabilityData(0))
				}, 500)
			}
		})
		.catch(error => {
				// Dispatch adaDescription GA events
				const profileUserData = {
					status: 'error'
				}

				triggerCustomGaEvent('analytics-profileFetchUser', profileUserData)
				dispatch(fetchProfileUserError(error))
				dispatch(setProfileAuthentication(false))
				dispatch(fetchAvailabilityData(0))
		})
	}
}

export function signOutProfileUser() {
	return (dispatch, getState) => {
		const activeRooms = getState().activeRoomData
		const piSriToken = getCookie('accorPiSriToken')

		let hasActiveMemberRoomRate = false

		for (let roomKey in activeRooms) {
			const currentRoom = activeRooms[roomKey]
			if (
				currentRoom &&
				currentRoom[1] &&
				currentRoom[1][0] &&
				currentRoom[1][0].ratePlanType === 'MEMBER'
			) {
				hasActiveMemberRoomRate = true
			}
		}

		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Basic ${btoa(process.env.REACT_APP_CRM_API_APP_ID + ':' + process.env.REACT_APP_CRM_API_SECRET_KEY)}`,
			'X-XSRF-HEADER': 'PingFederate'
		}


		const revokeSessionApi = `${process.env.REACT_APP_CRM_AUTH_PROVIDER_URL}/pf-ws/rest/sessionMgmt/revokedSris`

		dispatch(signOutProfileUserBegin())

		return axios.post(revokeSessionApi, {
			'id': piSriToken.toString()
		}, {
			headers: headers
		})
			.then((response) => {
				const userSession = _.get(response, 'data', null)

				if (userSession) {
					dispatch(setProfileModalVisibility(false))
					dispatch(setProfileAuthentication(false))
					dispatch(signOutProfileUserSuccess())

					removeCookie('accorAuthToken')
					removeCookie('accorPiSriToken')
					removeCookie('accorAuthCode')

					if (hasActiveMemberRoomRate) {
						dispatch(setActiveStep(0))
						dispatch(resetActiveRoom())
					}

					const profileSignOutData = {
						status: 'success'
					}

					triggerCustomGaEvent('analytics-profileSignOut', profileSignOutData)

					let sessionId = generateUuid()
					setCookie('flowSessionId', sessionId, 1)
				}
			})
			.catch(error => {
				dispatch(signOutProfileUserError(error))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchAccorProfileUser.js